// Pages/PaymentError.js
//
// Redsys/Getnet failure/cancel return URL (DS_MERCHANT_URLKO).
// The payment was denied or cancelled. No access is granted. Offer to retry.

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPendingPurchase, clearPendingPurchase } from '../utils/redsysCheckout';

function PaymentError() {
  const navigate = useNavigate();
  const pending = getPendingPurchase();
  const productId = pending?.productId || null;

  useEffect(() => {
    // No payment context (e.g. the URL was opened directly) -> send the user
    // home instead of showing a payment page out of nowhere.
    if (!productId) {
      navigate('/', { replace: true });
      return;
    }
    // The pending purchase did not complete; don't leave stale state around.
    clearPendingPurchase();
  }, [productId, navigate]);

  // Avoid flashing the error UI while redirecting a context-less visit.
  if (!productId) return null;

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.cross}>✕</div>
        <h1 style={styles.title}>Payment not completed</h1>
        <p style={styles.text}>
          Your payment was not completed or was cancelled. You have not been charged.
          You can try again.
        </p>
        <div style={styles.actions}>
          {productId && (
            <button style={styles.btnPrimary} onClick={() => navigate(`/product/${productId}`)}>
              Retry
            </button>
          )}
          <button style={styles.btnSecondary} onClick={() => navigate('/')}>
            Back to home
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  card: {
    maxWidth: 420,
    width: '100%',
    textAlign: 'center',
    background: '#15151a',
    border: '1px solid #2a2a33',
    borderRadius: 12,
    padding: '40px 28px',
    color: '#f2f2f5',
  },
  title: { fontSize: 24, margin: '16px 0 8px' },
  text: { color: '#b7b7c0', lineHeight: 1.5, marginBottom: 24 },
  cross: {
    width: 56,
    height: 56,
    lineHeight: '56px',
    borderRadius: '50%',
    background: '#e0245e',
    color: '#fff',
    fontSize: 26,
    margin: '0 auto',
  },
  actions: { display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' },
  btnPrimary: {
    background: '#1db954',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    padding: '12px 24px',
    fontSize: 15,
    cursor: 'pointer',
  },
  btnSecondary: {
    background: 'transparent',
    color: '#f2f2f5',
    border: '1px solid #3a3a44',
    borderRadius: 8,
    padding: '12px 24px',
    fontSize: 15,
    cursor: 'pointer',
  },
};

export default PaymentError;
